import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=02b72bc2&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=02b72bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b72bc2",
  null
  
)

export default component.exports